import Constants from "../Constants";
import {useState} from "react";
import {useNavigate} from "react-router-dom";

const CreateCategoryPage = ({mainUser}) => {

    const [categoryTitle, setCategoryTitle] = useState("");
    const [categoryCoverImage, setCategoryCoverImage] = useState({});
    const navigator = useNavigate();


    const formData = new FormData();
    const afterPostCreated = () => {
        navigator("/blog");
    }
    const onImageInserted = (e) => {
        e.preventDefault();
        setCategoryCoverImage(e.target.files[0]);
        // console.log(e.target.files[0]);
    }


    const uploadPost = async () => {
        formData.append('category_title', categoryTitle);
        formData.append('category_image', categoryCoverImage);
        let url = Constants.BaseUrl.concat("create_category");
        const res = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                /*'Content-Type': 'multipart/form-data',
                'Accept':'application/json',*/
                // 'Authorization': 'Bearer '.concat(sessionStorage.getItem("user") != null && JSON.parse(sessionStorage.getItem("user")).token),
                'Authorization': 'Bearer '.concat(mainUser.token),
            },
            body: formData,
        }).catch((reason) => (console.log(reason)));
        // console.log(await res.json());
        return JSON.stringify(await res.json());

    }

    const submitForm = async (e) => {
        e.preventDefault();
        const res = await uploadPost();
        let createAns = (JSON.parse(res));
        if (createAns.state === "success") {
            alert("دسته بندی با موفقیت ایجاد شد.")
            afterPostCreated();
        } else {
            alert("دسته بندی ایجاد نشد. در ذخیره سازی یا ارسال درخواست مشکلی پیش آمده است.");
        }

    }

    const cancelPost = (e) => {
        e.preventDefault();
        setCategoryTitle("");
        setCategoryCoverImage({});
        document.getElementById("cover_image_add").value = "";
    }


    return (
        <div className="container m-5">

            <div className="container mt-5 mx-auto p-2 text-center justify-content-center">

                <h2>ایجاد دسته بندی جدید</h2>

                <form onSubmit={submitForm}>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="category_title"
                                   className="col-form-label text-md-start text-center fw-bolder">عنوان دسته
                                بندی</label>
                            <input id="post_title" type="text"
                                   title="این قسمت را پر کنید."
                                   placeholder="عنوان دسته بندی"
                                   className="form-control"
                                   value={categoryTitle}
                                   name="category_title"
                                   required
                                   onChange={(e) => {
                                       e.preventDefault();
                                       setCategoryTitle(e.target.value);
                                       // console.log(e.target.value);
                                   }}
                                   maxLength="70"
                                   autoComplete="post_title"/>
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="cover_image_add"
                                   className="col-form-label text-md-end text-center fw-bolder">عکس کاور دسته
                                بندی</label>
                            <input id="cover_image_add" type="file"
                                   placeholder="عکس کاور دسته بندی"
                                   className="form-control"
                                   name="cover_image_add"
                                   onChange={onImageInserted}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3 mt-3 justify-content-center text-center">
                        <div className="col-md-12">
                            <button type="submit" className="btn btn-primary btn-lg m-2 text-light">
                                ایجاد دسته بندی
                            </button>
                            <button onClick={cancelPost} className="btn btn-secondary btn-lg text-light m-2">
                                انصراف
                            </button>
                        </div>
                    </div>
                </form>


            </div>
        </div>
    )
}

export default CreateCategoryPage;